import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { stringJoin } from "../../../../utils/functions";

import { OutboundLink } from "gatsby-plugin-google-gtag";
import { Link } from "gatsby";

import { StaticImage } from "gatsby-plugin-image";
import { LinkAnchors, ProductsLink } from "../../../../utils/links";

import * as NavbarStyles from "./navbar.module.scss";
import * as ProductsStyles from "../../../pages/beer/beer.module.scss";

interface NavbarProps {
    products: readonly Queries.BeerFragment[];
}

const MainNavbar: React.FC<NavbarProps> = ({ products }: NavbarProps) => {
    const productMenu = (
        <Nav.Item className="mx-3">
            <NavDropdown title="Beer" className="text-center">
                <div className={stringJoin(NavbarStyles.beerDropdown, "px-3 py-2")}>
                    {["Heritage", "Cream Ale", "Specialty", "Vault"].map((category) => (
                        <div className="text-center">
                            <NavDropdown.ItemText className="opacity-50 mt-2">{category}</NavDropdown.ItemText>
                            {products
                                .filter((node) => node.category === category)
                                .map((node) => (
                                    <NavDropdown.Item as={Link} to={ProductsLink(node?.slug)} className="py-2 px-5 text-wrap">
                                        {node?.name}
                                    </NavDropdown.Item>
                                ))}
                        </div>
                    ))}
                </div>
            </NavDropdown>
        </Nav.Item>
    );

    return (
        <section>
            <div className="bg-black py-2 d-print-none">
                <Container>
                    <p className="mb-0 text-white text-center text-lg-start">
                        An American Tradition since <strong>1878</strong>
                    </p>
                </Container>
            </div>
            <Navbar expand="lg" className={stringJoin(NavbarStyles.navbar, ProductsStyles.navbar)}>
                <Container className="d-flex flex-column align-items-center">
                    <Navbar.Brand as={Link} to="/" className="text-center me-0">
                        <StaticImage className={stringJoin(NavbarStyles.logoImg, "d-block")} src="../../../images/logos/logo.png" alt="Genesee Brewery Logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbar-nav" className="py-3 mt-3 mb-1 bg-black text-white border-0">
                        <span className="fs-3 text-uppercase" style={{ letterSpacing: "1px" }}>
                            Menu
                        </span>
                    </Navbar.Toggle>
                    <Navbar.Collapse id="navbar-nav" className="w-100">
                        <Nav
                            className={stringJoin(
                                NavbarStyles.nav,
                                ProductsStyles.nav,
                                "d-flex flex-column flex-lg-row align-items-center justify-content-between py-1 my-3 fw-bold text-uppercase"
                            )}
                        >
                            <Nav.Item className="mx-3">
                                <NavDropdown title="Brew House" className="text-center">
                                    <NavDropdown.Item as={Link} to="/brewhouse/tour/" className="py-2 px-5 text-center">
                                        Tours & Tastings
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/menu/" className="py-2 px-5 text-center">
                                        Restaurant & Bar Menu
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/whatsontap/" className="py-2 px-5 text-center">
                                        What&rsquo;s On Tap
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={OutboundLink} href="https://www.toasttab.com/genesee/giftcards" target="_blank" className="py-2 px-5 text-center">
                                        Brew House Gift Card
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        as={OutboundLink}
                                        href="https://store.geneseebeer.com/collections/all-products/products/genesee-online-store-gift-card"
                                        target="_blank"
                                        className="py-2 px-5 text-center"
                                    >
                                        Online Shop Gift Card
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/privateevents/" className="py-2 px-5 text-center">
                                        Private Events
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/events/" className="py-2 px-5 text-center">
                                        Calendar
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={OutboundLink} href="https://store.geneseebeer.com/" target="_blank" className="py-2 px-5 text-center">
                                        Gift Shop
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/" className="py-2 px-5 text-center">
                                        About
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/story/" className="py-2 px-5 text-center">
                                        Story
                                    </NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/brewhouse/contact/" className="py-2 px-5 text-center">
                                        Contact
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav.Item>
                            {productMenu}
                            <Nav.Link as={Link} to={LinkAnchors.ABOUT} className="mx-3">
                                About
                            </Nav.Link>
                            <Nav.Link as={Link} to={LinkAnchors.FINDER} className="mx-3">
                                Finder
                            </Nav.Link>
                            <Nav.Link as={OutboundLink} href="https://store.geneseebeer.com" target="_blank" className="mx-3">
                                Store
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </section>
    );
};

export default MainNavbar;
